import { supabase } from "@/integrations/supabase/client";

export interface AdminActionPayload {
  action_type: string;
  tenant_id?: string;
  tenant_name?: string;
  details?: Record<string, unknown>;
}

/**
 * Logs an admin action to admin_audit_log via the service-role edge function.
 * All platform admin actions MUST call this.
 */
export async function logAdminAction(payload: AdminActionPayload): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke("log-admin-action", {
      body: payload,
    });
    if (error) {
      console.error("Failed to log admin action:", error);
    }
  } catch (err) {
    console.error("logAdminAction error:", err);
  }
}
